module.exports = __webpack_public_path__ + "images/emoji/convenience_store.2b00afa230f9d536e70c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/convenience_store.png
// module id = hxsA
// module chunks = 1